<template>
    <!-- <label>{{$props.context.label}}</label> -->
    <div class="formTree">
        <!-- <Tree
            :nodes="tree.nodes"
            :config="tree.config"
            @nodeFocus="treeClick"
            ></Tree> -->

            <multiselect
                v-model="selectedValue"
                :options="options"
                label="name"
                track-by="id"
                placeholder="Zoek..."
                :show-no-options="false"
                @search-change="search"
                :multiple="false">
                </multiselect>

    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import "vue-multiselect/dist/vue-multiselect.css";
import { ref } from 'vue';

export default {
  components: {Multiselect},
  props: {
      context: {
          type:Object,
          required:true
      },
    //   nodes: {
    //       type:Object,
    //       required:true
    //   }
  },
  data() {
      return {
        selectedValue:false,
        options:[
            {id:1, name:'pietje'},
            {id:2, name:'klaasje'},
            {id:3, name:'jantje'},
            {id:4, name:'sjakie'},
            {id:5, name:'harrie'},
            
        ],
      }
  },
  methods: {
      
      handleInput(e) {
          console.log('handleInput', e)
            //this.$props.context.node.input(e.level.content)

      },
      async search(e) {
          console.log('search', e)
          return;
          const res = await this.callApi('post', '/search', {search:e});
          console.log(res.data.result)
          this.options = res.data.result;
      },
      
  },
  computed: {
    value() {
        return this.selectedValue;
        // var a = [];
        // this.selectedValue.forEach(id=>{
        //     a.push({id:id, name: this.options.find(o=>o.id==id).name})
        // })
        // return a;
    }
  },
  watch: {
      // context(newVal) {
      //     this.valueCopy = newVal;
      // }
  },
  created() {
        //console.log('autocomplete created', this.$props.context._value)
        
        if (!this.$props.context._value || this.$props.context._value == undefined)    return;
        this.$props.context._value.forEach(id=>{
            this.selectedValue = {id:id, name: this.options.find(o=>o.id==id).name};
            
        })

  },
  beforeMount() {
        //console.log('autocomplete beforeMount', this.$props.context._value)

  },
  beforeUnmount() {
        //console.log('autocomplete beforeUnmount', this.$props.context._value)
        // this.autocomplete.nodes = {};
        // this.autocomplete.config.roots = [];
        // this.autocomplete.config.leaves = [];
        // this.$props.context.attrs.nodes =[]
  },
  mounted() {
        //console.log('autocomplete mounted', this.$props.context._value)
        //debugger;
        
  }
}
// const props = defineProps({
//     context: Object,
// })
// console.log(props)
// var testval = ref(props.context.value)
// function handleInput(e) {
//     console.log(props)
//     console.log(e)
//     testval = e.level.content
//     //props.context.node.input(e.target.value)
//     //props.context.node.input(e.level.content)
//     //props.context.node.input('234')
// }

</script>


<style>


</style>